import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { JobPointeTransferService } from '../job-pointe-transfer.service';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-employee-attribute',
  templateUrl: './edit-employee-attribute.component.html',
  styleUrls: ['./edit-employee-attribute.component.scss'],
})
export class EditEmployeeAttributeComponent implements OnInit {
  isEditEmployeeModalOpen: boolean = false;
  modalSubscription: Subscription;
  rowSubscription: Subscription;
  jobBoardForm: FormGroup;
  selectedRow: any = {};

  constructor(private jobPointeTransferService: JobPointeTransferService) { }

  ngOnInit(): void {
    this.modalSubscription = this.jobPointeTransferService.editEmployeeModalIsOpenSource.subscribe(value => {
      if (value) this.isEditEmployeeModalOpen = value;
    });
  }
  ngOnDestroy(): void {
    this.modalSubscription.unsubscribe();
  }

  setDataToControl(field, value) { }

  handleClose() {
    this.isEditEmployeeModalOpen = false;
  }
  handleAdd(add) { }
}
